import { mapState, mapActions } from "vuex";
import { showError, showSnackBar } from "@/helpers/globalHelpers";
import moment from "moment";

export default {
  name: 'EvidenceView',

  data: () => ({
    loadingCostCenter: false,
    loadingActionPlan: false,
    isLoadingUsers: false,
    evidenceModalItem: null,
    openModalEvidence: false,
    isLoadingValidCostCenters: false,
    validCostCenters: [],
    userRole: [],
    headers: [
      { text: "Periodo", sortable: false, value: "register_date" },
      { text: "Plan de acción", sortable: false, value: "action_plan.description" },
      { text: "Servicio", sortable: false, value: "action_plan.service.format_name" },
      { text: "Gerencia", sortable: false, value: "action_plan.management.name" },
      { text: "Estado", sortable: false, value: "status" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    evidenceActionPlanFilters: {
      page: 1,
      limit: 20 || process.env.VUE_APP_PAGINATION_PER_PAGE,
      pagination: true,
      status: ['PENDIENTE', 'NO_COMPLETADO', 'OBSERVADO'],
      service: null,
      month: parseInt(moment().format('M')),
      year: parseInt(moment().format('Y')),
    },
    status: [
      { name: "COMPLETADO", value: "COMPLETADO" },
      { name: "PENDIENTE APR", value: "PENDIENTE" },
      { name: "NO COMPLETADO", value: "NO_COMPLETADO" },
      { name: "OBSERVADO", value: "OBSERVADO" },
      { name: "MODIFICADO", value: "MODIFICADO" }
    ],
    monthValues: [
      { name: "ENERO", value: 1 },
      { name: "FEBRERO", value: 2 },
      { name: "MARZO", value: 3 },
      { name: "ABRIL", value: 4 },
      { name: "MAYO", value: 5 },
      { name: "JUNIO", value: 6 },
      { name: "JULIO", value: 7 },
      { name: "AGOSTO", value: 8 },
      { name: "SETIEMBRE", value: 9 },
      { name: "OCTUBRE", value: 10 },
      { name: "NOVIEMBRE", value: 11 },
      { name: "DICIEMBRE", value: 12 },
    ],
    yearValues: []
  }),

  async created() {
    const companyId = localStorage.getItem("company_id");
    this.getAvailableYears({ company_id: companyId }).then((years) => {
      this.yearValues = years;
    });
    await Promise.all([
        this.getPlanType(),
        this.getCostCenterByUser()
    ]);
    await this.loadValidCostCenters();
    await this.getEvidenceActionPlan();
  },

  computed: {
    breadcrumbs() {
      return [
        {
          text: "Inicio",
          link: true,
          exact: true,
          disabled: false,
          to: {
            name: "Dashboard",
          },
        },
        {
          text: "Planes de acción",
          link: true,
          exact: true,
          disabled: true,
        },
      ];
    },

    ...mapState("auth", ["user"]),
    ...mapState("plan_type", ["planType"]),
    ...mapState("security", [
      "costCentersUser",
      "costCentersUserRole"
    ]),
    ...mapState("action_plan", ["actionPlansPagination", "actionPlans"]),
    ...mapState("evidence_action_plan", ["evidencesActionPlan", "evidencesActionPlanPagination"]),

    profiles() {
      const companies = this.$store.state.auth.user?.companies || [];
      const currentCompanyId = localStorage.getItem("company_id");
      const profiles = [];

      if (Array.isArray(companies)) {
        const company = companies.find(
          (c) => String(c.id) === String(currentCompanyId)
        );

        if (company) {
          company.profiles?.forEach((profile) => {
            profiles.push(profile.role);
          });
        }
      }

      return profiles;
    },

    isSuperAdmin() {
      return this.profiles.some(
        (profile) => profile.name === "Super Admin"
      );
    },

  },

  methods: {
    ...mapActions("security", [
      "getCostCenterUser",
      "getCostCenterUserRole"
    ]),

    ...mapActions("action_plan", ["deleteActionPlanSuperAdmin", "getAvailableYears"]),
    ...mapActions("plan_type", ["getPlanTypeByIdV2"]),
    ...mapActions("evidence_action_plan", [
      "listActionPlanPagination",
      "reverseEvidence",
      "deleteEvidence"
    ]),

    async getPlanType() {
            this.isLoadingPlanType = true;
            const { planTypeId } = this.$route.params;
            // const { error } = await this.getPlantypeById(planTypeId);
            const { error } = await this.getPlanTypeByIdV2(
                {
                    id: planTypeId,
                    onlyEntity: false,
                    relations: ['profiles'],
                    populate: true
                })
            if (error) showError(error);

            this.isLoadingPlanType = false;
        },

    async getCostCenterByUser() {
      this.loadingCostCenter = true;
      const { error } = await this.getCostCenterUserRole({
        user_id: this.user.id,
      });
      if (error) showError(error);
      this.loadingCostCenter = false;
    },

    loadValidCostCenters() {
            this.isLoadingValidCostCenters = true;
            const planTypeProfiles = this.planType?.profiles?.map(p => p.profile.id) || [];
            const userProfileIds = this.profiles.map(p => p.id);

            const matchingRoleIds = planTypeProfiles.filter(roleId =>
                userProfileIds.includes(roleId)
            );

            const validRoles = this.costCentersUserRole.filter(r =>
                matchingRoleIds.includes(r.role_id)
            );
            this.userRole = validRoles.map(r => r.role_id);
            this.validCostCenters = Array.from(
              new Map(
                validRoles
                  .flatMap(r => r.costCenters)
                  .map(cc => [cc.id, cc])
              ).values()
            );
            this.isLoadingValidCostCenters = false;
        },

    async getEvidenceActionPlan() {
      this.loadingActionPlan = true;
      const filters = {
        ...this.evidenceActionPlanFilters,
        type: 'CLIMA_LABORAL',
        user_role_id: this.userRole
      };

      if (filters.status && filters.status.length > 0) {
        filters.status = filters.status.join(',');
      } else {
        delete filters.status;
      }

      const { error } = await this.listActionPlanPagination(filters);
      if (error) showError(error);
      this.loadingActionPlan = false;
    },

    openModal(item) {
      try {
        this.evidenceModalItem = item;
        this.openModalEvidence = true;
      } catch (error) {
        showSnackBar("Error al abrir el modal:", "error");
      }
    },

    closeModalEvidence() {
      this.openModalEvidence = false;
    },

    formatDate(dateString) {

      if (!dateString) {
        return "-";
      }

      const dateOnly = moment.utc(dateString).format("DD/MM/YYYY");

      return dateOnly;
    },

    allowUpdate(evidenceActionPlan) {
      if (evidenceActionPlan &&
        evidenceActionPlan.action_plan.status === 'MODIFICADO' &&
        evidenceActionPlan.status !== 'MODIFICADO' ||
        evidenceActionPlan.status === 'COMPLETADO' ||
        evidenceActionPlan.status === 'PENDIENTE' ||
        evidenceActionPlan.status === 'OBSERVADO'
      ) {
        return false;
      } else if (evidenceActionPlan &&
        evidenceActionPlan.action_plan.status === 'MODIFICADO' &&
        evidenceActionPlan.status === 'MODIFICADO'
      ) {
        return true;
      } else {
        return true;
      }
    },

    setColorStatusEvidenceActionPlan(status) {
      switch (status) {
        case "EN_CURSO":
          return {
            background: "blue lighten-5",
            color: "blue",
            name: "EN CURSO",
            description: "Periodo en curso"
          };
        case "MODIFICADO":
          return {
            background: "yellow lighten-5",
            color: "yellow",
            name: "MODIFICADO",
            description: "Periodo en estado modificado"
          };
        case "COMPLETADO":
          return {
            background: "green lighten-5",
            color: "green",
            name: status,
            description: "Periodo completado"
          };
        case "ATRASADO":
          return {
            background: "grey lighten-3",
            color: "grey",
            name: status,
          };
        case "NO_COMPLETADO":
          return {
            background: "grey lighten-2",
            color: "grey",
            name: "NO COMPLETADO",
            description: "Periodo no completado"
          };
        case "PENDIENTE":
          return {
            background: "blue lighten-5",
            color: "blue",
            name: "PENDIENTE",
            description: "Periodo pendiente de aprobación"
          };
        case "OBSERVADO":
          return {
            background: "yellow lighten-4",
            color: "yellow darken-2",
            name: "OBSERVADO",
            description: "Periodo observado"
          };
      }
    },

    isAllowed() {
      return this.isSuperAdmin
    },

    confirmEvidence() {
      this.$swal({
        text: '¿Estás seguro de eliminar el periodo de este servicio?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#0039a6',
        cancelButtonColor: 'grey',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí',
      }).then(async (result) => {
        if (result.isConfirmed) {
          // const { evidenceActionPlanId } = this.$route.params;
          // const data = {
          //   company_id: parseInt(localStorage.getItem("company_id")),
          //   evidence_action_plan_id: evidenceActionPlanId,
          //   observed: false
          // }

          // const { error } = await this.confirmObservedEvidenceActionPlan(data);
          // if (error) showError(error);

          // this.$route.params.source !== 'evidenceActionPlan' ? this.getEvidenceActionPlan() : this.$router.push({ name: "ListEvidenceActionPlan" });
        }
      })
    },

    async confirmApprovedEvidence(evidenceActionPlan) {
      this.$swal({
        text: '¿Estás seguro de eliminar el periodo de este servicio?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#0039a6',
        cancelButtonColor: 'grey',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí',
      }).then(async (result) => {
        if (result.isConfirmed) {

          const { error } = await this.reverseEvidence(evidenceActionPlan.id);
          if (error) showError(error);

          await this.getEvidenceActionPlan()

        }
      })
    },

    async confirmDeleteEvidence(evidenceActionPlanId) {
      this.$swal({
        text: "¿Estás seguro de eliminar este periodo de evidencia?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0039a6",
        cancelButtonColor: "grey",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sí",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: "Eliminando...",
            text: "Por favor, espera.",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            willOpen: () => {
              this.$swal.showLoading();
            },
          });

          try {
            const { error } = await this.deleteEvidence(evidenceActionPlanId);

            if (error) {
              this.$swal("Error", "No se pudo eliminar la evidencia.", "error");
              return;
            }

            await this.getEvidenceActionPlan();
            this.$swal("Eliminado", "La evidencia fue eliminada con éxito.", "success");
          } catch (error) {
            this.$swal("Error", "Ocurrió un problema al eliminar la evidencia.", "error");
          }
        }
      });
    },

    async confirmDeleteActionPlan(actionPlanId) {

      this.$swal({
        text: "¿Estás seguro de eliminar este plan de acción?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0039a6",
        cancelButtonColor: "grey",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sí",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: "Eliminando...",
            text: "Por favor, espera.",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            willOpen: () => {
              this.$swal.showLoading();
            },
          });

          try {
            const { error } = await this.deleteActionPlanSuperAdmin({
              id: actionPlanId,
              payload: {},
            });

            if (error) {
              this.$swal("Error", "No se pudo eliminar el plan de acción.", "error");
              return;
            }

            await this.getEvidenceActionPlan();
            this.$swal("Eliminado", "El plan de acción fue eliminado con éxito.", "success");
          } catch (error) {
            this.$swal("Error", "Ocurrió un problema al eliminar el plan de acción.", "error");
          }
        }
      });
    }

  },
};